module.exports = __webpack_public_path__ + "static/satviko-e52df9d18ef76e5fdc28d1bcbb11cc22.jpg";